var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-show-layout',{attrs:{"title":_vm.title}},[_c('va-show',{attrs:{"item":_vm.item}},[_vm._v(" "+_vm._s(_vm.item)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }